// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import className from 'classnames/bind';

import * as forgotPasswordActions from '../store/actions';
import { getEmail, getInfo } from '../store/selectors';
import Navigation from '../../../common/Navigation/Navigation';
import styles from './styles';
import { Input, Button } from '../../../components';

class ForgotPasswordPage extends Component {
  state = {};

  static propTypes = {
    classes: PropTypes.object,
    email: PropTypes.string,
    onChangeInput: PropTypes.func,
    info: PropTypes.object,
    onSubmit: PropTypes.func,
    resetForm: PropTypes.func,
  };

  static defaultProps = {
    classes: {},
    email: null,
    onChangeInput: () => { },
    onSubmit: () => { },
    resetForm: () => { },
    info: {},
  };

  onSubmit = () => {
    this.props.onSubmit(this.props.email);
  }

  componentWillUnmount() {
    this.props.resetForm();
  }

  render() {
    const { classes } = this.props;

    return (
      <Navigation mobileLikeIndex={false}>
        <div className={classes.mainContainer}>
          <h4 className={classes.mainText}>FORGOT YOUR PASSWORD?</h4>
          <div className={classes.subContainer}>
            <h6 className={classes.subText}>No worries, it happens to all of us!</h6>
            <h6 className={classes.subText}>
              Just enter your email address below and we’ll send you a password reminder
            </h6>
            <Input
              name={'email'}
              placeholder={'enter your email'}
              style={classes.inputStyle}
              fixedWidth
              inputType={'email'}
              value={this.props.email}
              onChange={this.props.onChangeInput}
            />
            <h6 className={className(classes.infoText, this.props.info.status
              ? classes.successText : classes.errorText)}
            >
              {this.props.info.message}
            </h6>
            <Button onPress={this.onSubmit} style={classes.buttonStyle} text={'SUBMIT'} />
          </div>
        </div>
      </Navigation>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    email: getEmail(state),
    info: getInfo(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onSubmit: data => dispatch(forgotPasswordActions.submitForgotPassword(data)),
    onChangeInput: (value, name) => dispatch(forgotPasswordActions.changeField(value, name)),
    resetForm: () => dispatch(forgotPasswordActions.resetForm()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(ForgotPasswordPage));
